import { APIintegrationGet } from '../api/Integrations';

import { getState } from '../helpers/App';

export const SET_MINI_CONFIG = 'SET_MINI_CONFIG';
export const SET_MINI_LOCK = 'SET_MINI_LOCK';
export const SET_MINI_LOCK_FILE = 'SET_MINI_LOCK_FILE';
export const SET_MINI_SIDEBAR_OPEN = 'SET_MINI_SIDEBAR_OPEN';
export const RUN_MINI_FILE_ACTION = 'RUN_MINI_FILE_ACTION';
export const CLEAR_MINI_FILE_ACTION = 'CLEAR_MINI_FILE_ACTION';
export const SHOW_MODAL_MINI = 'SHOW_MODAL_MINI';
export const HIDE_MODAL_MINI = 'HIDE_MODAL_MINI';
export const SHOW_MODAL_TOP_MINI = 'SHOW_MODAL_TOP_MINI';
export const HIDE_MODAL_TOP_MINI = 'HIDE_MODAL_TOP_MINI';
export const SHOW_MODAL_TOP_SECOND_MINI = 'SHOW_MODAL_TOP_SECOND_MINI';
export const HIDE_MODAL_TOP_SECOND_MINI = 'HIDE_MODAL_TOP_SECOND_MINI';
export const SET_UPLOAD_PROGRESS = 'SET_UPLOAD_PROGRESS';
export const SHOW_MINI_CONFIRMATION_MODAL = 'SHOW_MINI_CONFIRMATION_MODAL';
export const HIDE_MINI_CONFIRMATION_MODAL = 'HIDE_MINI_CONFIRMATION_MODAL';
export const SET_MINI_OPENED_FILES = 'SET_MINI_OPENED_FILES';
export const SET_MINI_ACTIVE_FILE = 'SET_MINI_ACTIVE_FILE';
export const SET_MINI_OVERLAY = 'SET_MINI_OVERLAY';

export const setMiniConfig = config => ({
  type: SET_MINI_CONFIG,
  config,
});

export const setMiniLock = lock => ({
  type: SET_MINI_LOCK,
  lock,
});

export const setMiniLockFile = fileUuid => ({
  type: SET_MINI_LOCK_FILE,
  fileUuid,
});

export const setSidebarOpen = open => ({
  type: SET_MINI_SIDEBAR_OPEN,
  open,
});

export const runFileAction = (file, action, event = null, files = []) => ({
  type: RUN_MINI_FILE_ACTION,
  file,
  files,
  action,
  event,
});

export const clearMiniFileAction = () => ({
  type: CLEAR_MINI_FILE_ACTION,
});

export const fetchIntegration = (integrationId, params = {}) => dispatch => (
  APIintegrationGet(integrationId, params)
    .then((response) => {
      dispatch(setMiniConfig(response));
    })
    .catch(() => {
      dispatch(setMiniConfig(null));
    })
);

export const showModalMini = (modal, modalProps) => ({
  type: SHOW_MODAL_MINI,
  modal,
  modalProps,
});

export const hideModalMini = () => ({
  type: HIDE_MODAL_MINI,
});

export const showModalTopMini = (modal, modalProps) => ({
  type: SHOW_MODAL_TOP_MINI,
  modal,
  modalProps,
});

export const hideModalTopMini = () => ({
  type: HIDE_MODAL_TOP_MINI,
});

export const showModalTopSecondMini = (modal, modalProps) => ({
  type: SHOW_MODAL_TOP_SECOND_MINI,
  modal,
  modalProps,
});

export const hideModalTopSecondMini = () => ({
  type: HIDE_MODAL_TOP_SECOND_MINI,
});

export const setUploadProgress = uploadProgress => ({
  type: SET_UPLOAD_PROGRESS,
  uploadProgress,
});

export const showMiniConfirmationModal = params => ({
  type: SHOW_MINI_CONFIRMATION_MODAL,
  params,
});

export const hideMiniConfirmationModal = () => ({
  type: HIDE_MINI_CONFIRMATION_MODAL,
});

export const setMiniOpenedFiles = openedFiles => ({
  type: SET_MINI_OPENED_FILES,
  openedFiles,
});

export const setMiniActiveFile = activeFile => ({
  type: SET_MINI_ACTIVE_FILE,
  activeFile,
});

export const setMiniOverlay = overlay => {
  const state = getState();

  return {
    type: SET_MINI_OVERLAY,
    overlay: { ...state.Mini.overlay, ...overlay },
  };
};
